import React, { FC } from 'react';
import { Routes as RouterRoutes, Route } from 'react-router-dom';
import Callback from '../Callback';
import Login from '../Login';
import { Routes as AppRoutes } from '../../../utils';

const AuthContent: FC = (): React.JSX.Element => (
    <RouterRoutes>
        <Route path={AppRoutes.CALLBACK.route} element={<Callback />} />
        <Route path="*" element={<Login />} />
    </RouterRoutes>
);

export default AuthContent;
